import React from 'react'
import Logo from '../header/logo'
import { GrLocation } from "react-icons/gr";
import { MdOutlineMail } from "react-icons/md";
import { LuPhone } from "react-icons/lu";
import { FiLinkedin } from "react-icons/fi";
import { FiTwitter } from "react-icons/fi";
import { FiFacebook } from "react-icons/fi";
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <section className="footer bg-black">
            <div className="md:flex gap-5 w-full md:h-[350px] pt-20 mx-7 ">
                <div className="flex-1 ">
                    <Logo/>
                    <p className='md:mx-4 mt-8 md:mt-8 my-5 text-white text-sm text-left md:pr-0 pr-10'>Bridging Indian and Japanese <br></br>business practices through education and research excellence.</p>
                </div>
                <div className="flex-1 text-left  md:pl-5 md:ms-28">
                    <h3 className='text-xl text-white font-semibold '>Quick Links </h3>
                    <Link to='/about-mijsc'>  <p className='text-white text-sm my-5'> About Us</p> </Link>
                    <Link to='/hybrid-learning-platforms'> <p className='text-white text-sm my-5'> Programs </p> </Link>
                    <Link to='/mijsc-programs'> <p className='text-white text-sm my-5'> Events </p> </Link>
                    <Link to='/gallery'> <p className='text-white text-sm my-5'> Gallery </p> </Link>
                </div>
                <div className="flex-1 text-left">
                    <h3 className='text-xl text-white font-semibold'> Programs </h3>
                    <Link to='/faculty-development-program'><p className='text-white text-sm my-5'>Faculty Development </p> </Link>
                    <Link to='/skill-development'><p className='text-white text-sm my-5'>Student Skill Development </p> </Link>
                    <Link to='/consultancy-program'><p className='text-white text-sm my-5'>Consultancy Program </p> </Link>

                </div>
                <div className="flex-1 text-left pr-10">
                    <h3 className='text-xl text-white font-semibold'>Contact </h3>
                    <div className='flex gap-2 my-5 items-center'>
                        <GrLocation className='text-green-600 text-xl' />
                        <p className="text-white text-sm"> Indian Institute of Management,<br></br>Bangalore </p>
                    </div>
                    <div className='flex gap-2 my-5 items-center'>
                        <MdOutlineMail className='text-green-600 text-xl' />
                        <a
                            href="mailto:contact@mijsc.iimb.ac.in"
                            className="text-white text-sm"
                        > <p className="text-white text-sm " >contact@mijsc.iimb.ac.in </p> </a>
                    </div>
                    <div className='flex gap-2 my-5 items-center'>
                        <LuPhone className='text-green-600 text-xl' />
                        <a
                            href="tel:+919741376645"
                            className="text-white text-sm"
                        ><p className="text-white text-sm ">9741376645 </p></a>
                    </div>
                </div>
            </div>
            <div className='w-full h-1 border-t mb-5 border-gray-500'> </div>
            <div className='w-full flex  justify-between pb-5'>
                <p className='text-white pl-10 md:text-sm text-xs'>© 2025 MIJSC at IIMB. All rights reserved.</p>
                <div className='flex md:gap-5 gap-2 px-14'>
                    <FiLinkedin className='text-white' />
                    <FiTwitter className='text-white' />
                    <FiFacebook className='text-white' />
                </div>
            </div>
        </section>


    )
}

export default Footer
